import { checkResponse, get, post } from "@/utils/http";
import { APP_CONFIG } from "@/utils/constants";

export function getUserTransactions() {
  return get(`${APP_CONFIG.apiUrl}/transactions`).then(checkResponse);
}

export function getUserDeposits() {
  return get(`${APP_CONFIG.apiUrl}/deposits`).then(checkResponse);
}

export function getUserExams() {
  return get(`${APP_CONFIG.apiUrl}/user/exams`).then(checkResponse);
}

export function getUserExamCategory() {
  return get(`${APP_CONFIG.apiUrl}/user/exams/logs`).then(checkResponse);
}

export function getUserInfo(id) {
  return get(`${APP_CONFIG.apiUrl}/user/${id}`).then(checkResponse);
}

export function getCityList(data) {
  return get(`${APP_CONFIG.apiUrl}/location/cities`, data).then(checkResponse);
}

export function getWardList(data) {
  return get(`${APP_CONFIG.apiUrl}/location/wards`, data).then(checkResponse);
}

export function postDeposit(data) {
  return post(`${APP_CONFIG.apiUrl}/deposits`, data).then(checkResponse);
}

export function postCOD(data) {
  return post(`${APP_CONFIG.apiUrl}/deposits/activate`, data).then(checkResponse);
}